import { ToolbarProps } from "react-big-calendar";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { calendarCurrentMonthState } from "../../../recoil/calendar/calendarStateV2";
import { useJuneTrackCall } from "../../../utils/june/analytics";
import { useEffect, useState } from "react";
import moment from "moment";
import styles from "./header.module.css";
import { CALENDAR_VIEW_TYPE } from "../../../types/account/enum";
import { usePreference } from "../../../hooks/preference/usePreference";
import { DefaultPreferenceOptions } from "../../../constants/userPreference";

const CalendarHeaderTodayButton = ({ toolbar }: { toolbar: ToolbarProps }) => {
  const { preference: userPreference } = usePreference();

  const calendarView =
    userPreference?.calendarViewType ?? DefaultPreferenceOptions.calendarViewType;
  const setCalendarCurrentMonth = useSetRecoilState(calendarCurrentMonthState);
  const trackCall = useJuneTrackCall();

  const [isShowToday, setIsShowToday] = useState(false);

  const goToToday = () => {
    const now = new Date();
    toolbar.onNavigate("DATE", now);
    calendarView !== CALENDAR_VIEW_TYPE.MONTH &&
      setTimeout(() => {
        const wrapper = document.querySelector(".rbc-time-content");
        const element = document.querySelector(`.rbc-current-time-indicator`);
        if (!wrapper || !element) {
          return;
        }
        const wrapperBound = wrapper.getBoundingClientRect();
        wrapper.scrollTo({
          top: (element as HTMLElement).offsetTop - wrapperBound.height / 3,
          behavior: "smooth",
        });
      }, 200);
    trackCall("click_today");
    setCalendarCurrentMonth(moment(new Date(now)).format("YYYY-MM"));
  };

  useEffect(() => {
    const normalEl = document.querySelector(`.rbc-today`);
    const monthlyEl = document.querySelector(`.rbc-now`);
    normalEl || monthlyEl ? setIsShowToday(false) : setIsShowToday(true);
  }, [toolbar]);

  if (!isShowToday) return null;

  return (
    <div
      className={styles["today"]}
      onClick={goToToday}
    >
      Today
    </div>
  );
};

export default CalendarHeaderTodayButton;
